module.exports = __webpack_public_path__ + "static/media/galerija_2014 (27).393b047d.jpg";